import { buildApiUrl, Type, applyPagingToUrl, sendPaginationRequest } from '@/api/api';
import { z } from 'zod'

export const tariffDashboardSchema = z.object({
  assetCode: z.string(),
  projectName: z.string(),
  tariff: z.string(),
  yearOfTariff: z.string()
})

export async function fetchAssetTariffDashboard(
  params: Partial<{
    page: number
    pageSize: number
  }>) {
  const url = buildApiUrl(Type.AssetManagement, `asset/assets`);
    applyPagingToUrl(url, params.page, params.pageSize)
  return sendPaginationRequest(url, tariffDashboardSchema)
}
